import React, { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import { isAdmin } from './userRoles'
import { AuthContext } from '../components/contexts/AuthContext'
import { CloudContext } from '../components/contexts/CloudContext'

export default ({ component: WrappedComponent, adminOnly, superUserOnly }) => {
    const Authed = props => {
        const { selectedCloud } = useContext(CloudContext)
        const { user } = useContext(AuthContext)
        if (!user || (adminOnly && !isAdmin(user, selectedCloud)) || (superUserOnly && !user.isCoreSuperUser))
            return <Navigate to="/login" />

        return <WrappedComponent user={user} {...props} />
    }

    return Authed
}
